import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password should be 6+ characters");
    setBusy(true);
    const res = await register(email, password, name || "Friend");
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome to your journey ♡");
      nav("/");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md kawaii-card p-8 md:p-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-kawaii-mint via-kawaii-lavender to-kawaii-pink flex items-center justify-center shadow-md animate-float">
            <Sparkles className="w-8 h-8 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="mt-4 font-heading text-3xl font-semibold text-kawaii-text">Start your LymphieLog</h1>
          <p className="text-sm text-kawaii-textSoft mt-2 text-center">A soft, private space to track your healing</p>
          <div className="mt-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gradient-to-r from-kawaii-lavender/20 to-kawaii-pink/20 border border-kawaii-lavender/40">
            <Sparkles className="w-3 h-3 text-kawaii-lavender" strokeWidth={2.5} />
            <span className="text-[11px] font-body font-semibold text-kawaii-text">7 days of Pro, free · no card needed</span>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-kawaii-textSoft font-semibold">Your name</label>
            <input
              data-testid="register-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 w-full px-4 py-3 rounded-2xl border border-kawaii-border bg-white/60 focus:outline-none focus:ring-2 focus:ring-kawaii-pink font-body"
              placeholder="What should we call you?"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-kawaii-textSoft font-semibold">Email</label>
            <input
              data-testid="register-email"
              type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-4 py-3 rounded-2xl border border-kawaii-border bg-white/60 focus:outline-none focus:ring-2 focus:ring-kawaii-pink font-body"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-kawaii-textSoft font-semibold">Password</label>
            <input
              data-testid="register-password"
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-4 py-3 rounded-2xl border border-kawaii-border bg-white/60 focus:outline-none focus:ring-2 focus:ring-kawaii-pink font-body"
              placeholder="Minimum 6 characters"
            />
          </div>
          <button
            type="submit" disabled={busy}
            data-testid="register-submit"
            className="kawaii-btn w-full py-3 rounded-full font-heading font-semibold text-white bg-gradient-to-r from-kawaii-lavender to-kawaii-pink shadow-md disabled:opacity-60"
          >
            {busy ? "Creating..." : "Create my journal"}
          </button>
        </form>
        <p className="text-center text-sm text-kawaii-textSoft mt-6 font-body">
          Already have an account?{" "}
          <Link to="/login" data-testid="link-login" className="text-kawaii-pink font-semibold hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
